import { Image, Info } from 'components';

export default function RecommendedSampleSizeInfo() {

    return <Info>
        <Image alt="Magnifying glass being held over many people" path="recommended-sample-size.png" title="Recommended Sample Size" />
        <h5>Sample Size</h5>
        <p>
            The <span className="fst-italic">Recommended Sample Size</span> is the number of individuals you need to test or survey to learn something about your total <span className="fst-italic">Population</span> with the accuracy you want from your <span className="fst-italic">Target Margin of Error</span> and your <span className="fst-italic">Confidence Level</span>. It is calculated one of two ways:
            <br />
            <br />
            <span className="fw-bold text-decoration-underline">Using Threshold & Expected Results</span>
            <br />
            If there is no <span className="fst-italic">Target Margin of Error</span>, it&apos;s calculated assuming you want a <span className="fst-italic">Margin of Error</span> sufficient to identify a winner between the <span className="fst-italic">Expected Results</span> and the <span className="fst-italic">Threshold</span> or existing <span className="fst-italic">Results</span>.
        </p>
    </Info>;

}